import {
  MutationCache,
  QueryCache,
  QueryClient,
  type QueryObserverOptions,
} from "@tanstack/react-query";
import { toast } from "sonner";

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onSuccess: (_data, _variables, _context, _mutation) => {
      queryClient.invalidateQueries(
        {
          predicate: (query) => {
            if (
              (query.options as QueryObserverOptions).staleTime ===
              Number.POSITIVE_INFINITY
            ) {
              return false;
            }

            return true;
          },
        },
        { cancelRefetch: false },
      );
    },
    onError: (error, _variables, _context, mutation) => {
      if (
        (mutation.options.meta as { silentErrorToast?: boolean } | undefined)
          ?.silentErrorToast
      ) {
        return;
      }

      const response = (
        error as {
          response?: {
            message?: string;
            errors?: Array<{ message?: string }>;
          };
        }
      ).response;

      const messages = [
        response?.message,
        ...(response?.errors ?? []).map((entry) => entry.message),
      ].filter((message): message is string => Boolean(message));

      if (messages.length > 0) {
        toast.error(messages.join("\n"));
      }
    },
  }),
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (
        (query.meta as { silentErrorToast?: boolean } | undefined)
          ?.silentErrorToast
      ) {
        return;
      }

      const response = (
        error as {
          response?: {
            message?: string;
            errors?: Array<{ message?: string }>;
          };
        }
      ).response;

      const messages = [
        response?.message,
        ...(response?.errors ?? []).map((entry) => entry.message),
      ].filter((message): message is string => Boolean(message));

      if (messages.length > 0) {
        toast.error(messages.join("\n"));
      }
    },
  }),
});
